export default __webpack_public_path__ + "static/media/youtube.76813a9b.png";